// MapLoadingSpinner.js
import React from 'react';
import '../../assets/css/MapLoadingSpinner.css';

const MapLoadingSpinner = ({ visible = true }) => {
    if (!visible) return null;
    return (
        <div className="map-loading-spinner">
            <div className="spinner-circle" />
        </div>
    );
};

export default MapLoadingSpinner;